export default "__VITE_ASSET__Bh2iaaij__"